const testimonials = [
  {
    quote: "Paygent cut our payment processing costs by 38% and their API integration took less than a day. We migrated off Stripe and never looked back.",
    name: "Marcus Chen",
    title: "CTO, Dokan Commerce",
    avatar: "MC",
    color: "#2563EB",
  },
  {
    quote: "The Tapn product is a game-changer for events. We eliminated $12K in hardware rental costs at our last festival with zero downtime.",
    name: "Aisha Thompson",
    title: "COO, MatchdayATL",
    avatar: "AT",
    color: "#0D9488",
  },
  {
    quote: "Radar caught a $45K fraud ring that our previous provider missed completely. The AI-powered scoring is on another level.",
    name: "James Rivera",
    title: "VP Payments, TravelCierge",
    avatar: "JR",
    color: "#7C3AED",
  },
  {
    quote: "Their Connect product let us build marketplace payouts in two weeks. Split payments, vendor onboarding, compliance — all handled.",
    name: "Sarah Kim",
    title: "Head of Engineering, Vista Platforms",
    avatar: "SK",
    color: "#F59E0B",
  },
];

export default function TestimonialsSection() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-semibold bg-blue-50 text-blue-600 border border-blue-100 mb-4 tracking-wide">
            TESTIMONIALS
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Trusted by builders who ship fast</h2>
          <p className="text-lg text-gray-500 max-w-xl mx-auto">See what engineering leaders and operators say about Paygent.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {testimonials.map((t) => (
            <div
              key={t.name}
              className="bg-white p-8 rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow"
            >
              {/* Stars */}
              <div className="flex gap-0.5 mb-4">
                {[1, 2, 3, 4, 5].map(s => (
                  <i key={s} className="ri-star-fill text-amber-400 w-4 h-4 flex items-center justify-center" />
                ))}
              </div>
              
              <p className="text-gray-700 leading-relaxed mb-6 text-[15px]">"{t.quote}"</p>
              
              <div className="flex items-center gap-3 pt-4 border-t border-gray-100">
                <div
                  className="w-10 h-10 rounded-full flex items-center justify-center text-white font-bold text-sm flex-shrink-0"
                  style={{ background: t.color }}
                >
                  {t.avatar}
                </div>
                <div>
                  <div className="font-bold text-gray-900 text-sm">{t.name}</div>
                  <div className="text-xs text-gray-500">{t.title}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
